import React from "react";

import NewsPostVertical from "../../../widgets/NewsPostVertical";

const NewsSidebar = ({ siteId }) => {
  return <NewsPostVertical siteId={ siteId}/>;
};

export default NewsSidebar;
